/**
 * Export utilities for BookingsTable — CSV and Excel export.
 */

const EXPORT_HEADERS = [
  "Booking ID", "Date", "Selected Setup Time", "Customer Name", "Phone", "Email", "Package",
  "Occasion", "Address", "Payment Type", "Payment Amount", "Payment Status",
  "Booking Status", "Add-ons", "Notes", "Sales Executive", "Created At"
];

const bookingToRow = (b) => [
  b.id || "",
  b.date || "",
  b.setup_time || b.event_time || b.time_slot || "",
  (b.customer_name || "").replace(/,/g, " "),
  b.customer_phone || "",
  b.customer_email || "",
  b.package || "",
  b.occasion || "",
  (b.address || "").replace(/,/g, " ").replace(/\n/g, " "),
  b.payment_type || "",
  // Export in rupees (payment_amount / final_amount are stored in paise).
  b.payment_amount ? (b.payment_amount / 100).toFixed(2) : (b.final_amount ? (b.final_amount / 100).toFixed(2) : ""),
  b.payment_status || "",
  b.booking_status || b.status || "",
  (b.add_ons || []).map(a => typeof a === "string" ? a : a.name || a.id || "").join("; "),
  (b.notes || "").replace(/,/g, " ").replace(/\n/g, " "),
  b.sales_executive || "",
  b.created_at || "",
];

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

const getDateSuffix = () => new Date().toISOString().split("T")[0];

export const exportCSV = (rows) => {
  if (rows.length === 0) return;
  const csvRows = rows.map(b => bookingToRow(b));
  const csv = [EXPORT_HEADERS.join(","), ...csvRows.map(r => r.map(v => `"${v}"`).join(","))].join("\n");
  downloadBlob(new Blob([csv], { type: "text/csv" }), `doozygo-bookings-${getDateSuffix()}.csv`);
};

export const exportExcel = (rows) => {
  if (rows.length === 0) return;
  let html = `<html><head><meta charset="UTF-8"><style>td,th{border:1px solid #ccc;padding:6px 10px;font-family:Arial;font-size:12px}th{background:#E83E8C;color:white;font-weight:bold}</style></head><body><table>`;
  html += `<tr>${EXPORT_HEADERS.map(h => `<th>${h}</th>`).join("")}</tr>`;

  rows.forEach(b => {
    const vals = bookingToRow(b);
    html += `<tr>${vals.map(v => `<td>${v}</td>`).join("")}</tr>`;
  });
  html += `</table></body></html>`;

  downloadBlob(new Blob([html], { type: "application/vnd.ms-excel" }), `doozygo-bookings-${getDateSuffix()}.xls`);
};
